import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

import { COLORS } from "../../../constant/colors";
import SectionHeader, { sectionHeaderSizes, sectionHeaderAlignDirections } from '../../components/core-elements/SectionHeader';
import FormTextField from '../../components/core-elements/FormTextField';
import Button from '../../components/core-elements/Button';
import RevealButton from '../../components/core-elements/RevealButton';
import Spacer from '../../components/core-elements/Spacer';
import Divider from '../../components/core-elements/Divider';
import Icon from '../../components/core-elements/AppIcon';
import CheckBox from '../../components/core-elements/CheckBox';
import ClickableText from '../../components/core-elements/ClickableText';
import ActionIcon from '../../components/core-elements/ActionIcon';
import LinkText from '../../components/core-elements/LinkText';
import AcknowledgeCheckBox from '../../components/core-elements/AcknowledgeCheckBox';
import tfIconSrc from '../../../assets/thoughtfull/TF_Trademark_Stacked.png';
import { validateInputName, validateInputEmail, validateInputMobile } from '../../../util/form-validation';
import { saveLead } from "../../../api/lead-form";
import { useTranslation } from 'react-i18next';
import { triggerGAOnLeadFormSubmitClick } from '../../../util/ga';

const countryCode = process.env.REACT_APP_LEAD_FORM_API_COUNTRY_CALLING_CODE;

const NewCustomerLeadForm = ({ classes, onGoBack, onSubmitSuccess, isFullPage = false }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [nameErrorMessage, setNameErrorMessage] = useState('');
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [mobileErrorMessage, setMobileErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckedTnc1, setIsCheckedTnc1] = useState(false);
  const { t, i18n } = useTranslation();
  const currentBu = process.env.REACT_APP_BU ?? "hk";


  const clearErrorMessages = () => {
    setNameErrorMessage('');
    setEmailErrorMessage('');
    setMobileErrorMessage('');
  };

  const onSubmit = async () => {
    setIsLoading(true);
    clearErrorMessages();

    // Validate inputs
    let isValidationSuccess = true;
    if (!validateInputName(name)) { isValidationSuccess = false; setNameErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidName')); }
    if (!validateInputEmail(email)) { isValidationSuccess = false; setEmailErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidEmail')); }
    if (!validateInputMobile(mobile)) { isValidationSuccess = false; setMobileErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidMobile')); }
    if (!isValidationSuccess) { setIsLoading(false); return; }
    // return onSubmitSuccess(); // TEMP
    // Send to Lead Form API

    triggerGAOnLeadFormSubmitClick({ language: i18n.language, componentName: isFullPage ? 'lead form full page' : 'lead form popup' });
    try {
      const response = await saveLead({
        firstName: name,
        lastName: '',
        email,
        countryCode,
        cellPhone: mobile,
        language: i18n.language
      })
      if (!response.success || !response.result === true) { throw new Error('Internal Error Occur'); }
      onSubmitSuccess();
    } catch (err) {
      // TODO: Confirm the error behavior
      console.debug(err);
      setNameErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidName'));
      setEmailErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidEmail'));
      setMobileErrorMessage(t('eTriageResultPage.leadFormForTF.enterValidMobile'));
      setIsLoading(false);
    }

  };

  return (
    <div className={classes.container}>
      {
        (!!onGoBack && !isFullPage) &&
        <div className={classes.backIconContainer}>
          <ActionIcon type='arrowLeft' onClick={onGoBack} />
        </div>
      }
      <SectionHeader
        text={t('eTriageResultPage.leadFormForTF.title')}
        size={isFullPage ? sectionHeaderSizes.large : sectionHeaderSizes.medium}
        alignDirection={isFullPage ? sectionHeaderAlignDirections.center : sectionHeaderAlignDirections.left}
        onGoBack={!!isFullPage && onGoBack}
        rightIconSrc={tfIconSrc}
      />
      <div className={classes.formContainer}>
        <Spacer y={24} />
        <FormTextField title={t('eTriageResultPage.leadFormForTF.name')} type={'text'} value={name} onValueChange={(value) => { setName(value); setNameErrorMessage('') }} isError={!!nameErrorMessage} errorMessage={nameErrorMessage} />
        <Spacer y={16} />
        <FormTextField title={t('eTriageResultPage.leadFormForTF.email')} type={'email'} value={email} onValueChange={(value) => { setEmail(value); setEmailErrorMessage('') }} isError={!!emailErrorMessage} errorMessage={emailErrorMessage} />
        <Spacer y={16} />
        <FormTextField title={`${t('eTriageResultPage.leadFormForTF.mobileNumber')} (${countryCode})`} type={'tel'} value={mobile} onValueChange={(value) => { setMobile(value); setMobileErrorMessage('') }} inputPrefix={countryCode} isError={!!mobileErrorMessage} errorMessage={mobileErrorMessage} />
        <Spacer y={16} />
        {/* <div className={classes.tncContainer}>
          <div className={classes.checkboxContainer}>
            <CheckBox isChecked={isCheckedTnc1} onCheckUncheck={setIsCheckedTnc2} />
          </div>
          <div className={classes.tncTextContainer}>
            <span>{'I have read and accept the '}</span>
            <LinkText text={'terms & conditions'} onClick={() => { console.log('Clicked TnC') }} />
          </div>
        </div> */}
        <AcknowledgeCheckBox isChecked={isCheckedTnc1} onCheckUncheck={setIsCheckedTnc1} description={t(`eTriageResultPage.leadFormForTF.consent.${currentBu}`)} />
        <Spacer y={16} />
        <RevealButton title={t(`eTriageResultPage.leadFormForTF.getTrialCode`)} isDisabled={!isCheckedTnc1 || isLoading} onClick={onSubmit} />
      </div>
    </div>
  )
};

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backIconContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: 16,
  },
  // // TnC
  // tncContainer: {
  //   display: 'flex',
  //   flexDirection: 'row',
  // },
  // checkboxContainer: {
  //   display: 'inline-block',
  //   marginRight: 4,
  // },
  // tncTextContainer: {
  //   paddingTop: 2,
  // },
  formContainer: {
    width: '100%',
    maxWidth: 344,
  },
};

export default withStyles(styles)(NewCustomerLeadForm);
